const getFBK = (load: number, width: number, length: number) => {
  return (load * 10000) / Math.max(width * length, 1);
};

export { getFBK };
